class BackToTop {
  constructor(node) {
    this.rootElement = node;
    this.rootElement.addEventListener('click', this.onClick.bind(this));
  }

  onClick() {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion)');
    const target = this.rootElement.href;
    const urlFragment = new URL(target).hash;
    if (urlFragment !== undefined && urlFragment !== '') {
      history.pushState(null, null, urlFragment);

      const anchorElement = document.querySelector(`${urlFragment}`);
      if (anchorElement && !reducedMotion.matches) {
        anchorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'start'
        });
      }
    }
  }
}

const backToTopLink = document.querySelector('.c-back-to-top');
new BackToTop(backToTopLink);
